<template>
  <div class="newsletter">
    <div class="wrapper">
      <div class="text">Sign up for our newsletter, get 10% off your next order</div>
      <form
        class="Form u-alignMiddle"
        action="//cottonbureau.us2.list-manage.com/subscribe/post?u=72a12beb88773f8d735b1ef60&id=fd98d7df35"
        method="post"
        name="mc-embedded-subscribe-form"
        target="_blank"
        id="mailform"
        novalidate
      >
        <div class="Form-comboInput Form-comboInput--hollow Form-comboInput--small">
          <div class="Form-input Form-input--text Form-input--comboInput Form-input--hollow">
            <input class="Form-inputEl newsletter-signup-field" type="email" name="EMAIL" placeholder="discount@me.com" />
          </div>

          <input class="u-hiddenVisually" type="text" name="b_72a12beb88773f8d735b1ef60_fd98d7df35" value="" />

          <button class="Form-comboInput-attachment Form-button mail-submit" type="submit">
            <symbol-icon icon-name="mail" class="Icon--colorRed" view-box="0 0 96 72" />
            <span class="u-hiddenVisually">Submit</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { defineAsyncComponent } from "vue";
const SymbolIcon = defineAsyncComponent(() => import("@/components/symbol-icon.vue"));

export default {
  components: {
    SymbolIcon,
  },
};
</script>
